export const PRIVATE_SALES = {
  None: 0,
  PS100: 100,
  PS250: 250,
  PS500: 500,
};
